import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  partnerLogos = [
    {
      img: "assets/img/partner-img/partner-1.png",
      hoverImg: "assets/img/partner-img/partner-hover1.png"
    },
    {
      img: "assets/img/partner-img/partner-2.png",
      hoverImg: "assets/img/partner-img/partner-hover2.png"
    },
    {
      img: "assets/img/partner-img/partner-3.png",
      hoverImg: "assets/img/partner-img/partner-hover3.png"
    },
    {
      img: "assets/img/partner-img/partner-4.png",
      hoverImg: "assets/img/partner-img/partner-hover4.png"
    },
    {
      img: "assets/img/partner-img/partner-5.png",
      hoverImg: "assets/img/partner-img/partner-hover5.png"
    },
    {
      img: "assets/img/partner-img/partner-6.png",
      hoverImg: "assets/img/partner-img/partner-hover6.png"
    },
    {
      img: "assets/img/partner-img/partner-7.png",
      hoverImg: "assets/img/partner-img/partner-hover7.png"
    },
    {
      img: "assets/img/partner-img/partner-8.png",
      hoverImg: "assets/img/partner-img/partner-hover8.png"
    },
    {
      img: "assets/img/partner-img/partner-9.png",
      hoverImg: "assets/img/partner-img/partner-hover9.png"
    },
    {
      img: "assets/img/partner-img/partner-10.png",
      hoverImg: "assets/img/partner-img/partner-hover10.png"
    },
    {
      img: "assets/img/partner-img/partner-11.png",
      hoverImg: "assets/img/partner-img/partner-hover11.png"
    },
    {
      img: "assets/img/partner-img/partner-12.png",
      hoverImg: "assets/img/partner-img/partner-hover12.png"
    },
    {
      img: "assets/img/partner-img/partner-13.png",
      hoverImg: "assets/img/partner-img/partner-hover13.png"
    },
    {
      img: "assets/img/partner-img/partner-14.png",
      hoverImg: "assets/img/partner-img/partner-hover14.png"
    },
    {
      img: "assets/img/partner-img/partner-15.png",
      hoverImg: "assets/img/partner-img/partner-hover15.png"
    },
    {
      img: "assets/img/partner-img/partner-16.png",
      hoverImg: "assets/img/partner-img/partner-hover16.png"
    },
    {
      img: "assets/img/partner-img/partner-17.png",
      hoverImg: "assets/img/partner-img/partner-hover17.png"
    },
    {
      img: "assets/img/partner-img/partner-18.png",
      hoverImg: "assets/img/partner-img/partner-hover18.png"
    }
  ];


}
